import { useRegisterAction } from '../../hooks/useRegisterAction';
import styles from './ComparisonDisclaimer.module.css';

export default function ComparisonDisclaimer() {
  const register = useRegisterAction();

  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <div className={styles.cta}>
          <p className={styles.ctaText}>See the model for yourself: 7 days, no card.</p>
          <button
            className={styles.ctaBtn}
            onClick={register.go}
          >
            {register.label}
          </button>
        </div>

        <p className={styles.disclaimer}>
          All trademarks are the property of their respective owners. RepBuddy is not
          affiliated with or endorsed by any company mentioned.
        </p>
      </div>
    </section>
  );
}
